import { createApp } from 'vue';
import App from './App.vue';

export default createApp(App);
